if($('#should-scroll-to-posts').length) {
    // js scroll to .blog-post-listings
    let posts = $('.blog-post-listings');

    if(posts.length) {
        $('html, body').animate({
            scrollTop: posts.offset().top - 100
        }, 500);
    }

}
